"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elevationToBoxShadow = exports.hexToRGB = exports.invertColor = exports.shadeColor = exports.padZero = void 0;
function padZero(str, len) {
    var _len = len || 2;
    var zeros = new Array(_len).join('0');
    return (zeros + str).slice(-_len);
}
exports.padZero = padZero;
/**
 * Shades a hex value to a darker or lighter color.
 *
 * @param hex Hex value to invert
 * @param percent Decimal (percent)
 */
function shadeColor(hex, percent) {
    var R = parseInt(hex.substring(1, 3), 16);
    var G = parseInt(hex.substring(3, 5), 16);
    var B = parseInt(hex.substring(5, 7), 16);
    R = Math.round((R * (100 + percent)) / 100);
    G = Math.round((G * (100 + percent)) / 100);
    B = Math.round((B * (100 + percent)) / 100);
    R = R < 255 ? R : 255;
    G = G < 255 ? G : 255;
    B = B < 255 ? B : 255;
    var RR = R.toString(16).length === 1 ? "0" + R.toString(16) : R.toString(16);
    var GG = G.toString(16).length === 1 ? "0" + G.toString(16) : G.toString(16);
    var BB = B.toString(16).length === 1 ? "0" + B.toString(16) : B.toString(16);
    return "#" + RR + GG + BB;
}
exports.shadeColor = shadeColor;
/**
 * Inverts a hex value, and an black&white boolean, to an inverted HEX color value.
 *
 * @param hex Hex value to invert
 * @param bw Blaxk & white
 */
function invertColor(hex, bw) {
    var _hex = hex;
    if (_hex.indexOf('#') === 0) {
        _hex = _hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (_hex.length === 3) {
        _hex = _hex[0] + _hex[0] + _hex[1] + _hex[1] + _hex[2] + _hex[2];
    }
    if (_hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    var r = parseInt(_hex.slice(0, 2), 16);
    var g = parseInt(_hex.slice(2, 4), 16);
    var b = parseInt(_hex.slice(4, 6), 16);
    if (bw) {
        // http://stackoverflow.com/a/3943023/112731
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    }
    // invert color components
    var rr = (255 - r).toString(16);
    var gg = (255 - g).toString(16);
    var bb = (255 - b).toString(16);
    // pad each with zeros and return
    return "#" + padZero(rr) + padZero(gg) + padZero(bb);
}
exports.invertColor = invertColor;
/**
 * Converts a hex value, and an alpha value, to an RGB color value.
 *
 * @param hex Hex value to transform to RGB
 * @param alpha Alpha value
 */
var hexToRGB = function (hex, alpha) {
    if (!hex)
        return '#FFFFFF';
    var _hex = hex;
    if (_hex.length === 3) {
        _hex = _hex[0] + _hex[0] + _hex[1] + _hex[1] + _hex[2] + _hex[2];
    }
    // if (hex.length < 6) _hex = `${hex}${hex.substr(1)}`;
    var r = parseInt(_hex.slice(1, 3), 16);
    var g = parseInt(_hex.slice(3, 5), 16);
    var b = parseInt(_hex.slice(5, 7), 16);
    return alpha ? "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")" : "rgb(" + r + ", " + g + ", " + b + ")";
};
exports.hexToRGB = hexToRGB;
var elevationToBoxShadow = function (elevation) {
    var boxShadow = 'none';
    var hOffset = 0;
    var vOffset = 24;
    var blur = 40;
    var spread = 12;
    if (elevation && elevation !== 'none') {
        switch (elevation) {
            case 'small':
                boxShadow = hOffset + "px " + vOffset / 3 + "px " + blur / 3 + "px -" + spread / 3 + "px rgba(0,0,0,0.13)";
                break;
            case 'medium':
                boxShadow = hOffset + "px " + vOffset / 2 + "px " + blur / 2 + "px -" + spread / 2 + "px rgba(0,0,0,0.13)";
                break;
            case 'large':
                boxShadow = hOffset + "px " + vOffset + "px " + blur + "px -" + spread + "px rgba(0,0,0,0.13)"; // 0px 24px 40px -12px rgba(0,0,0,0.13)
                break;
            default:
                break;
        }
    }
    return boxShadow;
};
exports.elevationToBoxShadow = elevationToBoxShadow;
